import type { FleetVehicle } from "@/features/fleet/api/fleet.types";

/**
 * Aracın hızlı eylemi — yalnız zimmet yetkisiyle: müsait araçta teslim, zimmetli araçta iade.
 *
 * İKİ YERDE AYNI CEVAP (1 Kasım 2026): araç kartı ve üst arama (plakayı yaz → «İade al»). Kural
 * burada bir kez yazılı; iki kopya ayrışsa biri serviste ya da hasarlı bir araca teslim önerirdi.
 */
export function vehicleQuickAction(
  vehicle: Pick<FleetVehicle, "id" | "state" | "holder">,
  canAssign: boolean,
): { label: string; to: string } | null {
  if (!canAssign) return null;
  if (vehicle.state === "IN_POOL") return { label: "Zimmet ver", to: `/fleet/assignments/new?vehicle=${vehicle.id}` };
  if (vehicle.holder) return { label: "İade al", to: `/fleet/assignments/${vehicle.holder.assignmentId}/return` };
  return null;
}
